// JavaScript source code
import React, { useEffect } from 'react';
import "react-step-progress-bar/styles.css";
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import Hidden from '@material-ui/core/Hidden';
import { ProgressBar } from "react-step-progress-bar";
import clsx from 'clsx';

import useStyles from '../../styles/components/survey/stylesSurvey'
import SurveyHolderDetail from './SurveyHolderDetail'
import { DaysDiff } from '../../utils/helpers/others/UtilsHelper'
import { SurveyData } from '../../utils/services/cache/ClientCache'
import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'

const CloseSurvey = React.memo(({
    survey,
    surveyId,
    handleClickSurveyID
}) => {
    const classes = useStyles();
    const [openDetail, setOpenDetail] = React.useState(false);
    const [showScroll, setShowScroll] = React.useState(false)
    const date = `${survey.startDate.split(' ')[0]} - ${survey.endDate.split(' ')[0]}`
    let progressTitle;
    let milestonePoint;
    let milestonePoints = [];
    let milestonePercent = [];
    let endDateMilestone = [];
    let startDateMilestone = [];
    let missed = [];
    let getECB = [];
    let dateMilestone = [];
    let noreward = survey.surveyMilestoneModels.length <= 0 ? true : false;
    let bonusPoint = [];
    const totalPoint = survey.totalSectionRewardCoins + survey.completionBonusCoins;
    const total = DaysDiff(surveyStartDate, surveyEndDate);
    let today = new Date();
    let surveyStartDate = new Date(ConvertDateString.convertForDatePicker(survey.startDate))
    let surveyEndDate = new Date(ConvertDateString.convertForDatePicker(survey.endDate))
    let position = 0

    if (survey.isCompleted) {
        let dateCompleted = new Date(ConvertDateString.convertForDatePicker(survey.dateCompleted))
        progressTitle = <div className={clsx(classes.textDescription, classes.textDescriptionClosed)}> Completed on {dateCompleted.toDateString()} </div>
    }
    else {
        progressTitle = <div className={clsx(classes.textDescription, classes.textDescriptionExpired)}> Expired on {surveyEndDate.toDateString()} </div>
    }

    if (!noreward) {
        survey.surveyMilestoneModels.forEach((element) => {
            let value = element;
            let startDate = new Date(ConvertDateString.convertForDatePicker(value.startDate));
            let endDate = new Date(ConvertDateString.convertForDatePicker(value.endDate));
            let milestoneTotal = DaysDiff(surveyStartDate, endDate);
            milestonePoints.push(value.bonusCoins);
            milestonePercent.push(Math.floor(100 - (((total - milestoneTotal) / total) * 100)));
            endDateMilestone.push(endDate)
            startDateMilestone.push(startDate)
            dateMilestone.push(`${moment(new Date(startDate)).format('DD/MM/YYYY')} - ${moment(new Date(endDate)).format('DD/MM/YYYY')}`)
            if (today >= startDate && today < endDate) {
                missed.push(false);
                milestonePoint = value.bonusCoins;
                SurveyData.setMilestoneRewardPoint(milestonePoint)
            }
            else if (today < endDate) {
                missed.push(false);
                milestonePoint = value.bonusCoins;
            }
            else {
                missed.push(true);
                milestonePoint = 0;
            }
            bonusPoint.push((survey.completionBonusCoins + survey.totalSectionRewardCoins + milestonePoint));
        });
    }

    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop)
        return () => window.removeEventListener("scroll", checkScrollTop);
    }, []);

    const handleClickOpen = () => {
        if (survey.isCompleted) {
            let dateCompleted = new Date(ConvertDateString.convertForDatePicker(survey.dateCompleted))
            startDateMilestone.forEach((item, index) => {
                if (dateCompleted >= startDateMilestone[index] && dateCompleted <= endDateMilestone[index])
                    getECB.push(true);
                else
                    getECB.push(false);
            })

            handleClickSurveyID(survey.surveyId)
            SurveyData.setSurveyGroupId(survey.surveyId);
            SurveyData.setGroupCompletionBonusPoint(survey.completionBonusCoins)
            SurveyData.setSurveyName(survey.title)
            if (survey.isCompleted) {
                survey.date = date
                survey.totalPoint = totalPoint
                survey.progressPercent = 100
                survey.milestonePercent = milestonePercent
                survey.bonusPoint = bonusPoint
                survey.missed = missed
                survey.noreward = noreward
                survey.dateMilestone = dateMilestone
                survey.milestones = {
                    bonusPoint: milestonePoints,
                    missed: missed,
                    getECB: getECB,
                    noreward: noreward,
                    dateMilestone: dateMilestone,
                }
            } else {
                survey.date = date
                survey.totalPoint = 0
                survey.progressPercent = 100
                survey.milestonePercent = []
                survey.bonusPoint = []
                survey.missed = []
                survey.noreward = true
                survey.dateMilestone = []
                survey.milestones = {
                    bonusPoint: [],
                    missed: [],
                    getECB: [],
                    noreward: true,
                    dateMilestone: [],
                }
            }
            survey.position = position
            setOpenDetail(true)
        }
    };

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false)
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <Accordion
                classes={{
                    root: classes.rootAccordion,
                    expanded: classes.expandedAccordion,
                    rounded: classes.roundedAccordion,
                }}
                onClick={() => handleClickOpen()}>
                <AccordionSummary
                    classes={{
                        root: classes.rootAccordionSummary,
                        content: classes.contentAccordionSummary,
                        expanded: classes.expandedAccordionSummary,
                    }}
                >
                    <Grid
                        item xs={12}
                        container
                        justify="center"
                        alignItems="center"
                        classes={{ root: classes.rootGridContent }}
                    >
                        <Grid item xs={12}>
                            <div className={clsx(classes.textTitle)}> {survey.title} </div>
                        </Grid>
                        <Grid item xs={12}>
                            {progressTitle}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            container
                            classes={{ root: classes.containerProrgessBar }}
                        >
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.rootAccordionDetailsSurvey }}>
                    {openDetail &&
                        <Hidden lgUp>
                            <Grid container>
                                <SurveyHolderDetail survey={survey} setOpenDetail={setOpenDetail} />
                            </Grid>
                        </Hidden>
                    }
                </AccordionDetails>
            </Accordion >
            {openDetail && openDetail && survey.surveyId === surveyId &&
                <Hidden mdDown>
                    <Grid classes={{ root: clsx(classes.layoutDetail, showScroll && classes.layoutDetailSroll) }}>
                        <Grid container>
                            <SurveyHolderDetail survey={survey} setOpenDetail={setOpenDetail} />
                        </Grid>
                    </Grid>
                </Hidden>
            }
        </div>
    );
});

export { CloseSurvey as default }

//<Grid item xs={12} classes={{ root: classes.wrapperProrgessBarCoin }}>
//    <ProgressBar
//        height={20}
//        filledBackground="#61B2C4"
//        percent={100}
//    />
//</Grid>